import { Modal } from '../../../../../components/Modal/Modal'
import { useState } from 'react'
import { LinkNewEmailModalBody } from './LinkNewEmailModalBody'
import { LinkNewEmailVerificationSentBody } from './LinkNewEmailVerificationSentBody'
import { useClaimExternalUserMutation } from '../../../../../store/user/user'
import { useAppSelector } from '../../../../../store/hooks'
import { selectAccountId } from '../../../../../store/auth/authSlice'
import { IntegrationServiceId } from '../../../../../common/integrations'
import { useGetMeQuery } from '../../../../../store/user/user'
import { TrackEvent, useTracking } from '../../../../../apps/professional-app/fa/common/tracking'

export interface LinkNewEmailModalProps {
  onHide: () => void
}

export const LinkNewEmailModal = ({ onHide }: LinkNewEmailModalProps) => {
  const [email, setEmail] = useState<string | null>(null)
  const accountId = useAppSelector(selectAccountId)
  const { data: currentUser } = useGetMeQuery({ accountId })
  const [claimExternalUser, { isLoading: isSending }] = useClaimExternalUserMutation()
  const { tracked } = useTracking()

  const existingDelegatedEmails =
    currentUser?.integrations
      ?.filter((i) => i.serviceId === IntegrationServiceId.DELEGATED_EMAIL)
      .map((i) => i.externalId)
      .filter((externalId) => externalId != null) ?? []

  const _handleSendLinkClicked = async (delegatedEmail: string) => {
    try {
      await claimExternalUser({
        accountId,
        integrationName: IntegrationServiceId.DELEGATED_EMAIL,
        payload: { delegatedEmail: delegatedEmail },
      }).unwrap()
      setEmail(delegatedEmail)
    } catch {
      onHide()
    }
  }

  const handleSendLinkClicked = tracked(_handleSendLinkClicked, {
    eventName: TrackEvent.DELEGATED_EMAIL_ADD,
    eventDetails: {
      userId: currentUser?.id,
    },
  })

  return (
    <Modal
      header={<></>}
      body={
        <>
          <div className='d-flex w-100 justify-content-center mb-3'>
            <h5 className='mb-0'>Link new email</h5>
          </div>
          {!email ? (
            <LinkNewEmailModalBody
              onSendLinkClicked={handleSendLinkClicked}
              isSending={isSending}
              currentUserEmail={currentUser?.email}
              existingDelegatedEmails={existingDelegatedEmails}
            />
          ) : (
            <LinkNewEmailVerificationSentBody email={email} onHide={onHide} />
          )}
          <p className='paragraph-small py-3'>
            This address is kept private. Read our{' '}
            <a target='_blank' href='https://www.zocks.io/privacy-policy' rel='noreferrer' className='button-link-small zocks-text-gray-900'>
              Privacy Policy
            </a>
          </p>
        </>
      }
      show
      onHide={onHide}
    />
  )
}
